// extracted by mini-css-extract-plugin
module.exports = {"evaluator":"evaluator-next_evaluator__34zOy","title":"evaluator-next_title__3k57f","separator":"evaluator-next_separator__3xN9x"};